'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ADD_AVAILABILITY_MESSAGE_TIMEOUT = exports.ADD_AVAILABILITY_MESSAGE_TIMEOUT = 'ADD_AVAILABILITY_MESSAGE_TIMEOUT';


//////////////////
// WEBPACK FOOTER
// ./js/availability/constants/actionTypes.js
// module id = 390
// module chunks = 2 3